import { Controller } from "@hotwired/stimulus"

import React from "react"
import { render } from "react-dom"

import { isNotAValue } from "web/services/helpers"

import DayPicker from "web/components/DayPicker/DayPicker"

export default class DateSelectController extends Controller {
  static targets = ["renderElement", "date"]

  initialize() {
    global.React = React
  }

  connect() {
    if (this.hasRenderElementTarget) {
      this.render(this.dateTarget.value)
    }
  }

  render(value) {
    this.#setInput(value)
    this.renderCalendar(DayPicker, value, this.#selectedDateLabel(value))
  }

  renderCalendar(Component, value, label) {
    render(
      <div className="flex flex-grow flex-col space-y-5 md:flex-row md:space-x-3 md:space-y-0">
        <div className="flex flex-col md:min-w-xs">
          <div className="mx-6 border-b-2 border-blue-600">{label}</div>
          <Component value={value} onChange={(value) => this.render(value)} />
        </div>
      </div>,
      this.renderElementTarget
    )
  }

  #setInput(value) {
    this.dateTarget.value = value

    if (this.dateTarget.type === "hidden") {
      this.dateTarget.dispatchEvent(new Event("change"))
    }
  }

  #selectedDateLabel(value) {
    if (isNotAValue(value)) {
      return "Please select a date"
    }

    return value
  }
}
